import { Component } from '@angular/core';
import { ReportGetter } from '../../directives/ReportGetter';
import { ReportBuilderService } from '../../services/report-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { GuardService } from '@shared/services';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { ISignature } from '@shared/interfaces';

@Component({
    selector: 'app-report-side-bar',
    templateUrl: './report-side-bar.component.html',
    styleUrls: ['./report-side-bar.component.scss'],
    standalone: false
})
export class ReportSideBarComponent extends ReportGetter {
    constructor(
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    get innerWidth() {
        return window.innerWidth;
    }

    get miDoc(): number {
        if (IS_TRS_PROJECT) {
            return (
                (this.builder.report?.responsibleSignature ? 1 : 0) +
                ((this.builder.report?.specialistSignature as ISignature[])?.length ?? 0) /
                    (1 + this.specialistSigners?.length)
            );
        }

        if (IS_PRODUCT_SAFETY_PROJECT) {
            return (
                ((this.builder.report?.responsibleSignature ? 1 : 0) +
                    (this.builder.report?.specialistSignature ? 1 : 0)) /
                2
            );
        }
    }

    get miTitle(): string {
        return !this.burgerOpen && innerWidth < 1000
            ? '1'
            : this.burgerOpen && innerWidth < 1000
              ? 'report.item.mainInformationAbbr'
              : 'report.item.mainInformation';
    }
}
